import {Injectable} from '@angular/core';
import {Http, Headers, URLSearchParams} from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import { environment } from '../../environments/environment';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class HttpService {
    http: Http;
    baseUrl = environment.baseApiUrl;

    private _accessToken: string;
    get accessToken(): string {
        return this.cookieService.get("btphat");
    }

    set accessToken(token: string) {
        this.cookieService.set("btphat", token, 14, '/');
    }


    constructor(
        http: Http,
        private toastr: ToastsManager,
        private cookieService: CookieService,
        private router: Router) {
        this.http = http;
    }

    public getUrl(route: string): string {
        return `${this.baseUrl}${route}`
    }

    private logError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

    handleError(error: any, message: string): void {
        console.log(`There was an error thrown by the service: ${message}`, error);
        if (error.status === 401) {
            this.toastr.error("Your session has expired. Please login again or contact your administrator for assistance.")
            this.router.navigate(['/login'], {queryParams: {clearSession: true}})
        } else if (error.status === 403) {
            this.toastr.error("You don't have access to that resource.  Please contact your administrator for assistance.");
        } else {
            this.toastr.error(message)
        }
    }

    get(route: string, parms: any): any{
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        let url = this.getUrl(route);
        if (this.accessToken) {
            parms.access_token = this.accessToken;
        }
        let params = new URLSearchParams();
        for (let key in parms) {
            let value = parms[key];
            params.set(key, value);
        }
        return this.http.get(url, {
            headers: headers,
            search: params
        }).toPromise()
        .then(result => result.json())
        .catch(this.logError)
    }

    post(route: string, data: any, accessToken?: string): any {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        let url = this.getUrl(route);
        let parms: any = {};
        if (this.accessToken || accessToken) {
            parms.access_token = accessToken || this.accessToken;
        }

        let params = new URLSearchParams();
        for (let key in parms) {
            let value = parms[key];
            params.set(key, value);
        }
        return this.http.post(url, JSON.stringify(data), {
            headers: headers,
            search: params
        }).toPromise()
            .then(function(result){
                //some statuses won't return any data
                try {
                    return result.json();
                } catch (err) {
                    return null;
                }
                // if (result.status != 204 && result.status != 201) {
                //     return result.json()
                // } else {
                //     return null;
                // }
            })
            .catch(this.logError)
    }

    postImage(route: string, data: any): any {
        let headers = new Headers();
        headers.delete('Content-Type');
        let url = this.getUrl(route);
        let parms: any = {};
        if (this.accessToken) {
            parms.access_token = this.accessToken;
        }

        let params = new URLSearchParams();
        for (let key in parms) {
            let value = parms[key];
            params.set(key, value);
        }
        return this.http.post(url, data, {
            headers: headers,
            search: params
        }).toPromise()
            .then(function(result){
                //some statuses won't return any data
                if (result.status != 204 && result.status != 201) {
                    return result.json().result.files.uploadFile[0];
                } else {
                    return null;
                }
            })
            .catch(this.logError)
    }

    delete(route: string, data?: any): any {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      let url = this.getUrl(route);
      let parms: any = {};
      if (this.accessToken) {
        parms.access_token = this.accessToken;
      }

      let params = new URLSearchParams();
      for (let key in parms) {
        let value = parms[key];
        params.set(key, value);
      }

      return this.http.delete(url, {
        headers: headers,
        search: params
      }).toPromise()
        .then(function(result){
          //some statuses won't return any data
          if (result.status != 204 && result.status != 201) {
            return result.json()
          } else {
            return null;
          }
        })
        .catch(this.logError)

    }

    put(route: string, data: any): any {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        let url = this.getUrl(route);
        let parms: any = {};
        if (this.accessToken) {
            parms.access_token = this.accessToken;
        }

        let params = new URLSearchParams();
        for (let key in parms) {
            let value = parms[key];
            params.set(key, value);
        }

        return this.http.put(url, JSON.stringify(data),{
            headers: headers,
            search: params
        }).toPromise()
            .then(function(result){
                //some statuses won't return any data
                if (result.status != 204 && result.status != 201) {
                    return result.json()
                } else {
                    return null;
                }
            })
            .catch(this.logError)

    }

    patch(route: string, data: any): any {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        let url = this.getUrl(route);
        let parms: any = {};
        if (this.accessToken) {
            parms.access_token = this.accessToken;
        }

        let params = new URLSearchParams();
        for (let key in parms) {
            let value = parms[key];
            params.set(key, value);
        }

        return this.http.patch(url, JSON.stringify(data),{
            headers: headers,
            search: params
        }).toPromise()
            .then(function(result){
                //some statuses won't return any data
                if (result.status != 204 && result.status != 201) {
                    return result.json()
                } else {
                    return null;
                }
            })
            .catch(this.logError)

    }
}



// WEBPACK FOOTER //
// ./src/app/services/http.service.ts